<template>
  <div v-if="currentUser.permissions.includes('tip.read')">
    <div class="row px-0 px-md-44 py-16 py-md-32">
      <div class="col-12 mb-24 small d-flex">
        <router-link class="text-dark d-flex" :to="{ name: 'admin-tips', query: { type: data.profession_type_id } }">
          <i-back class="i-14 mr-16 fill-gold my-auto"></i-back>
          {{ $t('general.back') }}
        </router-link>
        <router-link v-if="tips.length > 0 && nextTip" class="text-dark d-flex ml-auto" :to="{ name: 'admin-tips-show', params: { id: nextTip.id } }">
          {{ $t('general.next') }} tip
          <i-back class="i-14 ml-16 fill-gold my-auto" style="transform: rotate(180deg)"></i-back>
        </router-link>
      </div>

      <div class="col-12 mb-16 mt-32" v-if="$root.sizer === 'sm'">
        <el-select class="small  mb-0 w-100" v-model="lang" @input="translationChanged()" :options="languages" :hasLabel="false" :placeholder="$t('form-elements.language_placeholder')"></el-select>
      </div>

      <div v-if="tips.length > 0" class="col-12 d-flex flex-row mb-24">
        <div class="px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer opacity-100 d-flex flex-row" :class="{ 'bg-border-color': filter === 1 }" @click="goToTip(1)">
          <i-sun class="i-14 mr-8 my-auto d-none d-md-block"></i-sun>
          {{ $t('pages.advice.dayservice') }}
        </div>
        <div class="px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer opacity-100 d-flex flex-row" :class="{ 'bg-border-color': filter === 2 }" @click="goToTip(2)">
          <i-repeat class="i-14 mr-8 my-auto d-none d-md-block"></i-repeat>
          {{ $t('pages.advice.shifts') }}
        </div>
        <div class="px-8 px-md-24 py-8 mr-8 text-primary-dark opacity-50 c-pointer opacity-100 d-flex flex-row" :class="{ 'bg-border-color': filter === 3 }" @click="goToTip(3)">
          <i-user class="i-14 mr-8 my-auto d-none d-md-block"></i-user>
          {{ $t('pages.advice.non_working') }}
        </div>
        <el-select
          v-if="$root.sizer !== 'sm'"
          class="small ml-auto mb-0"
          v-model="lang"
          @input="translationChanged()"
          :options="languages"
          :hasLabel="false"
          :placeholder="$t('form-elements.language_placeholder')"
        ></el-select>
      </div>

      <el-form @submit="updateTip" class="col-12">
        <template slot="default">
          <p class="fw-b mb-16">Tip dag {{ data.day }}</p>

          <el-error class="mb-16" :error="server_error"></el-error>

          <div class="row form-content">
            <div class="col-12 col-md-6">
              <el-input v-model="data.title" type="text" name="psychologist" :label="$t('form-elements.title')" :placeholder="$t('form-elements.title_placeholder')"></el-input>

              <label class="small"> Tags </label>
              <vue-tags-input class="mb-16" v-model="tag" :tags="tags" @tags-changed="newTags => (tags = newTags)" />

              <el-file-upload
                class="mb-16"
                v-model="data.files"
                @reset="
                  data.file_preview = '';
                  data.files = [];
                "
                :preview="data.file_preview"
              ></el-file-upload>
              <el-audio-upload class="mb-16" v-model="data.audio_files" @reset="handleResetAudio" :previews="data.audio_file_previews"></el-audio-upload>
            </div>
            <div class="col-12 col-md-6">
              <el-rich-text class="mb-16" v-model="data.preview" name="preview" :label="$t('form-elements.preview')" :placeholder="$t('form-elements.preview_placeholder')"></el-rich-text>
              <el-rich-text v-model="data.content" name="content" :label="$t('form-elements.content')" :placeholder="$t('form-elements.content_placeholder')"></el-rich-text>
            </div>
          </div>
        </template>

        <template slot="footer">
          <div class="form-footer position-fixed px-lg-60">
            <button type="submit" class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" v-bind:class="{ disabled: loading }">
              {{ $t('general.save') }}
              <template v-if="loading">
                <i-loader class="ml-2 i-20 my-auto"></i-loader>
              </template>
              <template v-if="success">
                <i-check class="ml-2 i-20 my-auto"></i-check>
              </template>
            </button>
          </div>
        </template>
      </el-form>
    </div>
  </div>
  <div v-else class="container" style="height: calc(100% - 68px)">
    <div class="row h-100">
      <div class="col-auto m-auto">
        <image-no-access height="300"></image-no-access>
        <h4 class="text-primary-dark fw-b text-center mt-32">{{ $t('errors.no_admin_access') }}</h4>
        <p class="text-center">{{ $t('errors.no_admin_access_desc') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ElForm, ElSelect, ElInput, ElError, ElFileUpload, ElRichText, ElAudioUpload } from '@/components/forms'
import VueTagsInput from '@johmun/vue-tags-input';

// Extends
import hasForm from '@/components/forms/has-form';
import hasLanguages from '@/components/forms/has-languages';

export default {

    name: 'page-tips-show',

    mixins: [hasForm, hasLanguages],

    components: { ElForm, ElInput, ElSelect, ElError, ElFileUpload, ElRichText, VueTagsInput, ElAudioUpload },

    data: () => ({
        filter: 1,
        tag: "",
        tags: [],
        data: {
            title: '',
            preview: '',
            content: '',
            profession_type_id: null,
            day: null,
            tip_categories: [],
            files: [],
            file_preview: '',
            audio_files: [],
            audio_file_previews: [],
            clear_audio: []
        },
        tip: null
    }),
    mounted() {
        this.$store.dispatch('tips/readTip', this.$route.params.id).then((tip) => {
            this.data.id = tip.id
            this.data.title = tip.title
            this.data.preview = tip.preview
            this.data.content = tip.content
            this.data.day = tip.day
            this.filter = tip.profession_type_id
            this.data.profession_type_id = tip.profession_type_id
            this.tags = tip.tip_categories.map(tag => { return { text: tag, tiClasses: ['ti-valid'] } })
            this.data.tip_categories = tip.tip_categories
            this.data.file_preview = tip.file_preview
            this.data.audio_file_previews = tip.audio_file_previews
            this.data.clear_audio = [];
            this.setLanguage(tip.language)
        })
    },
    methods: {
        updateTip() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    this.data.tip_categories = this.tags.map(tag => tag.text)
                    this.$store.dispatch('tips/updateTip', this.data).then(
                        () => {
                            this.loading = false
                            this.success = true
                            this.data.clear_audio = [];
                            if (this.data.files && this.data.files.length) {
                                this.data.file_preview = { default: this.data.files[0].blob }
                                this.data.files = []
                            }

                            if (this.data.audio_files && this.data.audio_files.length) {
                                this.data.audio_files.forEach((f) => {
                                    this.data.audio_file_previews.push({ default: f.blob })
                                })
                                this.data.audio_files = []
                            }

                            this.$toasted.global.info({
                                title: this.$t('toasts.success_update_tip'),
                                description: this.$t('toasts.success_update_tip_desc'),
                            });
                            setTimeout(() => {
                                this.success = false
                            }, 5000);
                        },
                        (e) => this.handleError(e)
                    )
                }
            })
        },
        handleResetAudio(ids){
           this.data.clear_audio = ids;
           this.data.audio_file_previews = [];
           this.data.audio_files = [];
        },
        goToTip(profession) {
            this.$router.push({ name: 'admin-tips-show', params: { id: this.tips.find((t) => { return (t.profession_type_id === profession && t.language === this.lang.value) }).id } })
        },
        translationChanged() {
            this.$router.push({ name: 'admin-tips-show', params: { id: this.tips.find((t) => { return (t.day === this.data.day && t.profession_type_id === this.data.profession_type_id && t.language === this.lang.value) }).id } })
        }
    },
    computed: {
        tips() {
            return this.$store.getters['tips/all']
        },
        nextTip() {
            if (this.tips.length > 0)
                return this.tips.find((t) => { return (t.day === this.data.day + 1 && t.profession_type_id === this.data.profession_type_id && t.language === this.lang.value) })

            return false
        },
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>
